export const soaDefaultsTitles = {
	conveyancingFees: 'Legal Fees',
	hstDisbursements: 'HST Disbursements',
	nonHstDisbursements: 'Non HST Disbursements',
};
